<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!verificarPermissao('PERM_LISTAR_CENTRAL_CLIENTE')">
            <div style="text-align: center;">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="verificarPermissao('PERM_LISTAR_CENTRAL_CLIENTE')">
            
            <div class="flex justify-content-center" *ngIf="exibirSpinnerPrincipal">
                <p-progressSpinner></p-progressSpinner>
            </div>
            <div *ngIf="messagemVisivel" class="w-full mb-5">
                <p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
            </div>
            <div class="w-full" *ngIf="!exibirSpinnerPrincipal">
                <h5>{{clienteSelecionado?.nome}}</h5>
                <p-table #tbPacotes [value]="listaPacotes" dataKey="id" [rows]="5" [rowHover]="true"
                    [paginator]="true" [globalFilterFields]="['descricao']" responsiveLayout="scroll"
                    styleClass=" p-datatable-sm">
                    <ng-template pTemplate="header">
                        <tr>
                            <th pSortableColumn="tipoPagamentoOrigem.descricao">
                                Nº
                                <p-sortIcon field="tipoPagamentoOrigem.descricao">
                                </p-sortIcon>
                            </th>
                            <th pSortableColumn="tipoPagamentoDestino.descricao">
                                Data
                                <p-sortIcon field="tipoPagamentoDestino.descricao">
                                </p-sortIcon>
                            </th>
                            <th pSortableColumn="valorTransferido">
                                Status
                                <p-sortIcon field="valorTransferido">
                                </p-sortIcon>
                            </th>
                            <th>
                                Ações
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-item>
                        <tr>
                            <td>
                                {{item.numeroOrcamento}}
                            </td>
                            <td>
                                {{item.dataOrcamento | date:'dd/MM/yyyy'}}
                            </td>
                            <td>
                                {{item.status}}
                            </td>
                            <td>
                                <button pButton pRipple pTooltip="Detalhar"
                                    (click)="redirecionarPagina('/apps/central-cliente/pacote/detalhar/' + item.id)"
                                    icon="pi pi-eye" class="p-button-info mr-2 mb-2"></button>
                            </td>

                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="7">Nenhum registro encontrado.</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="loadingbody">
                        <tr>
                            <td colspan="7">Carregando. Por favor aguarde.</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
            <div class="formgroup" *ngIf="!exibirSpinnerPrincipal">
                <div class="p-fluid p-formgrid grid justify-content-end">
                    <div class="col-12 md:col-4 flex justify-content-end">
                        <button type="button" pButton class="p-button-outlined md:w-9rem mt-5" icon="pi pi-arrow-left"
                            label="Voltar" routerLink="/apps/central-cliente">
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>